import React from 'react';

import {StepHeader} from 'src/components/step-header';

import {ENTITLEMENTS_SUB_TABS} from '../constants';
import {entitlementsSubTabTitle} from '../entitlements-subtab.module.styl';
import {EntitlementsTabBar} from '../entitlements-tabs';

import {DatasetEntitlementsTab} from './dataset-entitlements-tab';

type Props = {
    accountId: number,
};

export const DatasetEntitlementsSubTab = ({accountId}: Props) => (
    <>
        <EntitlementsTabBar
            accountId={accountId}
            activeSubTab={ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS.name}
        />
        <div className={entitlementsSubTabTitle}>
            <StepHeader title={ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS.caption}/>
        </div>
        <DatasetEntitlementsTab key={accountId} accountId={accountId}/>
    </>
);
